import type { RouteRecordRaw } from 'vue-router';
export const helpdeskRoutes: RouteRecordRaw[] = [
  {
    path: 'helpdesk',
    name: 'helpdesk',
    component: () => import('../pages/helpdesk/HelpdeskPage.vue'),
    meta: { requiresModule: 'helpdesk' },
  },
];
